import SocialMediaGroup from './SocialMediaGroup';

export default SocialMediaGroup;
